import { createElement, useState, useCallback, useEffect, useMemo } from 'react';
import { Button } from 'antd';
import { difference } from 'lodash';
import TableSelect from './_components/TableSelect';
import { isDef, isFunc, isArr, useClosure, isObj } from '../../utils';
import API from '../../services';
const rowKey = 'storeCode';
function StoreTableSelect({ immediatelyRequest = false, type = 'shop', btnText = '请选择', title = '添加店铺', value: valueProps, multiple = true, placeholder = '请输入店铺名称/店铺编号', validator, validatorTip, onChange, modalProps, tableProps, children, ...restProps }) {
    const { value, setValue } = useValue(valueProps);
    const getKey = useCallback((record) => {
        if (isFunc(rowKey)) {
            return rowKey(record);
        }
        return rowKey;
    }, []);
    const [dataSource, setDataSource] = useState([]);
    const storeCategory = useMemo(() => (type === 'store' ? 4 : type === 'shop' ? 6 : ''), [type]);
    const columns = useMemo(() => [
        {
            title: `${type === 'store' ? '门店' : '店铺'}编号`,
            dataIndex: 'storeCode',
            width: 200,
        },
        {
            title: `${type === 'store' ? '门店' : '店铺'}全称`,
            dataIndex: 'storeName',
            width: 200,
        },
    ], [type]);
    useEffect(() => {
        immediatelyRequest && getDataSource({ storeCategory });
    }, []);
    const getDataSource = useCallback(({ storeCategory, storeName }) => {
        API.getAllStoreList({
            storeName,
            storeCategory,
            isActive: storeCategory === 6 ? 1 : undefined,
        })
            .then((res) => {
            isObj(res) && isArr(res.data) && setDataSource(res.data);
        });
    }, []);
    const onSearch = useCallback((value) => {
        getDataSource({ storeCategory, storeName: value });
    }, [storeCategory]);
    const onOk = useCallback(useClosure((newValue) => {
        if (isFunc(onChange)) {
            const newKeys = newValue.map((record) => record[String(getKey(record))]);
            const oldKeys = value.map((record) => record[String(getKey(record))]);
            const newDiffKeys = difference(newKeys, oldKeys);
            const oldDiffKeys = difference(oldKeys, newKeys);
            const newData = newValue.filter((record) => newDiffKeys.includes(record[String(getKey(record))]));
            const oldData = value.filter((record) => oldDiffKeys.includes(record[String(getKey(record))]));
            onChange([...newValue], newData, oldData);
        }
        setValue([...newValue]);
    }), [onChange]);
    return (createElement("div", { className: "store-table-select-wrapper", ...restProps },
        createElement(TableSelect, { title: title, placeholder: placeholder, columns: columns, dataSource: dataSource, rowKey: rowKey, value: value, multiple: multiple, validator: validator, validatorTip: validatorTip, onSearch: onSearch, onOk: onOk, ...modalProps, ...tableProps }, children || createElement(Button, { type: "primary" }, btnText))));
}
function useValue(valueProp) {
    const [value, setValue] = useState(valueProp || []);
    useEffect(() => {
        if (isDef(valueProp)) {
            setValue([...valueProp]);
        }
    }, [valueProp]);
    return { value, setValue };
}
StoreTableSelect.displayName = 'StoreTableSelect';
export default StoreTableSelect;
